module.exports = {
  "source": ".FeaturedBenefit__bulletListItem___i6sZ-{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex; }\n\n.FeaturedBenefit__vertical___2GT6g{\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n      -ms-flex-direction:column;\n          flex-direction:column; }\n\n.FeaturedBenefit__vertical___2GT6g .FeaturedBenefit__imageContainer___10PAh{\n    margin-right:0; }\n\n.FeaturedBenefit__imageContainer___10PAh{\n  margin-right:15px; }\n\n.FeaturedBenefit__imageContainer___10PAh svg,\n  .FeaturedBenefit__imageContainer___10PAh img{\n    display:block;\n    margin:0 auto; }\n\n.FeaturedBenefit__imageContainer___10PAh img{\n    width:100%; }\n\n.FeaturedBenefit__contentContainer___JfCpb{\n  text-align:center; }\n",
  "classNames": {
    "bulletListItem": "FeaturedBenefit__bulletListItem___i6sZ-",
    "vertical": "FeaturedBenefit__vertical___2GT6g",
    "imageContainer": "FeaturedBenefit__imageContainer___10PAh",
    "contentContainer": "FeaturedBenefit__contentContainer___JfCpb"
  },
  "classNameHash": {
    "FeaturedBenefit__bulletListItem___i6sZ-": "bulletListItem",
    "FeaturedBenefit__vertical___2GT6g": "vertical",
    "FeaturedBenefit__imageContainer___10PAh": "imageContainer",
    "FeaturedBenefit__contentContainer___JfCpb": "contentContainer"
  }
};

module.exports.getClassName = function(name, defaultValue) {
    return module.exports.classNames[name] || defaultValue;
};

module.exports.getClassNameHash = function(name, defaultValue) {
  return module.exports.classNameHash[name] || defaultValue;
};

module.exports.toString = function() {
  return module.exports.source;
};
